// Keeps a small snapshot of each customer's design in their own browser, so the cart can show the
// frame they made instead of the product's sample picture. Snapshots are 360 px wide: fine for a
// thumbnail, far too small to print from. Nothing is uploaded.
(function () {
  var PREFIX = 'ora-design:';
  var KEEP = 30;
  var WIDTH = 360;

  function store() {
    try { return window.localStorage; } catch (e) { return null; }
  }

  // Remove the oldest snapshots so the browser's storage never fills up
  function prune(ls) {
    var keys = [];
    for (var i = 0; i < ls.length; i++) {
      var k = ls.key(i);
      if (k && k.indexOf(PREFIX) === 0) keys.push(k);
    }
    if (keys.length <= KEEP) return;
    keys.map(function (k) {
      try { return { k: k, t: JSON.parse(ls.getItem(k)).t || 0 }; } catch (e) { return { k: k, t: 0 }; }
    }).sort(function (a, b) { return a.t - b.t; }).slice(0, keys.length - KEEP).forEach(function (x) { ls.removeItem(x.k); });
  }

  // Diagonal ORA FRAMES pattern drawn into the snapshot itself, in a dark and a light pass so it
  // shows on both pale and dark designs. A copied snapshot carries it with it.
  function watermark(ctx, w, h) {
    ctx.save();
    ctx.font = '600 13px Georgia, serif';
    ctx.textAlign = 'center';
    ctx.translate(w / 2, h / 2);
    ctx.rotate(-28 * Math.PI / 180);
    var span = Math.ceil(Math.sqrt(w * w + h * h) / 2);
    for (var y = -span; y <= span; y += 58) {
      for (var x = -span; x <= span; x += 150) {
        var dx = x + ((y / 58) % 2 ? 75 : 0);
        ctx.fillStyle = 'rgba(60, 48, 38, 0.16)';
        ctx.fillText('O R A   F R A M E S', dx, y);
        ctx.fillStyle = 'rgba(255, 255, 255, 0.13)';
        ctx.fillText('O R A   F R A M E S', dx + 1, y + 1);
      }
    }
    ctx.restore();
  }

  // Save a snapshot of the preview canvas. Returns the design id to add to the cart item, or ''.
  function save(canvas) {
    var ls = store();
    if (!ls || !canvas || !canvas.width) return '';
    try {
      var id = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      var small = document.createElement('canvas');
      small.width = WIDTH;
      small.height = Math.round(WIDTH * canvas.height / canvas.width);
      var ctx = small.getContext('2d');
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(canvas, 0, 0, small.width, small.height);
      watermark(ctx, small.width, small.height);
      var data = small.toDataURL('image/jpeg', 0.82);
      prune(ls);
      ls.setItem(PREFIX + id, JSON.stringify({ t: Date.now(), d: data }));
      return id;
    } catch (e) {
      return '';
    }
  }

  function get(id) {
    var ls = store();
    if (!ls || !id) return '';
    try { return (JSON.parse(ls.getItem(PREFIX + id)) || {}).d || ''; } catch (e) { return ''; }
  }

  // Cart: swap each item's sample picture for the customer's own design when we have it
  function fillCart() {
    document.querySelectorAll('[data-design-id]').forEach(function (el) {
      var src = get(el.getAttribute('data-design-id'));
      var img = src && el.querySelector('img');
      if (!img) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = src;
      img.setAttribute('draggable', 'false');
      var mat = img.closest('.ora-mat');
      if (mat) mat.classList.add('ora-glass');
      el.classList.add('is-customer-design');
    });
  }

  // No "Save image" menu, drag-out or long-press save on product and design pictures
  document.addEventListener('contextmenu', function (e) {
    if (e.target.closest && e.target.closest('.ora-frame, .ora-card__stage, .ora-product__stage, .ora-product__thumbs, .ora-reviews__photo')) e.preventDefault();
  });
  document.addEventListener('dragstart', function (e) {
    if (e.target.tagName === 'IMG') e.preventDefault();
  });


  // "Arrives by" dates (snippets/ora-arrive-by.liquid): today + preview and printing + the longest delivery
  // time, counting working days only (couriers don't deliver on Sundays)
  function fillArriveBy() {
    var fmt = function (d) {
      try { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { return d.toDateString().slice(0, 10); }
    };
    var addWorkingDays = function (n) {
      var d = new Date();
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; }
      return d;
    };
    document.querySelectorAll('[data-arrive]').forEach(function (el) {
      var lead = parseInt(el.dataset.lead, 10) || 2;
      var l = el.querySelector('[data-arrive-lahore]'), o = el.querySelector('[data-arrive-other]');
      if (l) l.textContent = fmt(addWorkingDays(lead + (parseInt(el.dataset.lahore, 10) || 5)));
      if (o) o.textContent = fmt(addWorkingDays(lead + (parseInt(el.dataset.other, 10) || 7)));
      el.hidden = false;
    });
  }

  window.OraDesignThumb = { save: save, get: get, fillCart: fillCart };
  function ready() { fillCart(); fillArriveBy(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
